module.exports = __webpack_public_path__ + "static/media/logo-kings-and-priests.e777bb32.png";